import { render, staticRenderFns } from "./complain_list.vue?vue&type=template&id=12a1783c&"
import script from "./complain_list.vue?vue&type=script&lang=js&"
export * from "./complain_list.vue?vue&type=script&lang=js&"
import style0 from "./complain_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports